import {
  Dropdown,
  useIsDesktop,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {ScrollView} from 'native-base';
import React from 'react';
import {useWindowDimensions} from 'react-native';

export interface YearDropdownProps {
  selectYear: (year: string) => void;
  selectedYear: string;
  years: string[];
}

const YearDropdown = (props: YearDropdownProps) => {
  const {selectYear, selectedYear, years} = props;
  const {height} = useWindowDimensions();
  const isDesktop = useIsDesktop();
  const dropdownMaxHeight = isDesktop ? `${height / 2}px` : `${height / 4}px`;

  const renderYears = () => {
    return years.map((year: string) => {
      return (
        <Dropdown.Item
          key={`year-dropdown-item-${year}`}
          onPress={() => selectYear(year)}
          minW="60px">
          {year}
        </Dropdown.Item>
      );
    });
  };

  return (
    <Dropdown label="YEAR" value={selectedYear} error="">
      <ScrollView maxHeight={dropdownMaxHeight}>{renderYears()}</ScrollView>
    </Dropdown>
  );
};

export default YearDropdown;
